export const managementSubnavStyles = {
    tabs: 'flex w-fit flex-wrap items-center gap-1 rounded-xl bg-slate-100 p-1',
    tab: 'rounded-lg px-5 py-2 text-sm font-bold transition-colors',
    activeTab: 'bg-white text-blue-600 shadow-sm',
    inactiveTab: 'text-slate-500 hover:bg-white/50 hover:text-slate-700',
};
